import type { EnterApiHttpEvents, EnterHttpError, HttpRetryEvent, HttpRetryExhaustedEvent } from '@enter/api';

/**
 * API 传输层事件的广播。ApiProvider 在应用层，展示反馈的组件在各区域的文案 Provider 之下，
 * 两边通过浏览器事件解耦：API 只广播，是否提示、如何提示由订阅方决定。
 */
export const RETRY_AFTER_EVENT = 'http_retry_after';
export const RETRY_EXHAUSTED_EVENT = 'http_retry_exhausted';
export const FINAL_HTTP_ERROR_EVENT = 'http_final_error';

interface ApiHttpEventMap {
    [RETRY_AFTER_EVENT]: HttpRetryEvent;
    [RETRY_EXHAUSTED_EVENT]: HttpRetryExhaustedEvent;
    [FINAL_HTTP_ERROR_EVENT]: EnterHttpError;
}

export function dispatchApiHttpEvent<K extends keyof ApiHttpEventMap>(name: K, detail: ApiHttpEventMap[K]): void {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(name, { detail }));
}

export function subscribeApiHttpEvent<K extends keyof ApiHttpEventMap>(
    name: K,
    listener: (detail: ApiHttpEventMap[K]) => void,
): () => void {
    const handle = (event: Event) => listener((event as CustomEvent<ApiHttpEventMap[K]>).detail);
    window.addEventListener(name, handle);
    return () => window.removeEventListener(name, handle);
}

/** App 注入 ApiProvider 的重试事件。 */
export const apiRetryEvents = {
    onRetryAfter: (event) => dispatchApiHttpEvent(RETRY_AFTER_EVENT, event),
    onRetryExhausted: (event) => dispatchApiHttpEvent(RETRY_EXHAUSTED_EVENT, event),
} satisfies EnterApiHttpEvents;
